<div>
    <v-select :value="value"
              :items="items"
              multiple
              chips
              deletable-chips
              return-object
              item-text="rejectionText"
              item-value="id"
              :label="$t('dashboardPage.rejectreason')"
              :disabled="disabled"
              @input="onSelected">
        <template slot="prepend-item">
            <v-list-tile ripple @click.stop="toggleSelectAll">
                <v-list-tile-action>
                    <i aria-hidden="true" class="v-icon material-icons theme--light">{{ selectAllIcon }}</i>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{$t('shared.selectAll')}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
        </template>
    </v-select>
    <div class="form-group" v-if="otherSelected">
        <v-textarea clearable
                    clear-icon="mdi-close-circle"
                    no-resize
                    rows="3"
                    maxlength="700"
                    :label="$t('dashboardPage.otherRejectionReason')"
                    required
                    :value="otherText"
                    @input="onOtherInput">
        </v-textarea>
    </div>
</div>
